export default "__VITE_ASSET__88bcb2d7__"